import React from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { createPortal } from 'react-dom'

interface ModalTitleProps {
  children: React.ReactNode
}

function Title({ children }: ModalTitleProps) {
  return <h2 className="font-bold text-lg mb-4">{children}</h2>
}

interface ModalFooterProps {
  children: React.ReactNode
  className?: string
}

function Footer({ children, className }: ModalFooterProps) {
  return <div className={`flex justify-start mt-6 gap-4 ${className}`}>{children}</div>
}

interface ModalContainerProps {
  className?: string
  isOpen: boolean
  children: React.ReactNode
  onClickOutside?: (isOpen: boolean) => void
  noPadding?: boolean
}

function Container({
  isOpen,
  children,
  onClickOutside,
  className,
  noPadding = false,
}: ModalContainerProps) {
  const handleClickInside = (e: React.MouseEvent) => {
    e.stopPropagation()
  }

  const handleClickOutside = (e: React.MouseEvent) => {
    e.stopPropagation()
    onClickOutside?.(false)
  }

  return createPortal(
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="fixed inset-0 flex items-center justify-center z-[110] font-sans"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={handleClickOutside}
        >
          <motion.div
            className={`bg-white rounded-lg border border-[#d2dbd7] shadow-[0px_5px_20px_0px_#0000001A] max-w-[500px] w-full ${
              noPadding ? '' : 'px-10 py-8'
            } ${className}`}
            onClick={handleClickInside}
          >
            {children}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>,
    document.body,
  )
}

export const Modal = {
  Container,
  Footer,
  Title,
}
